import { NON_ARRAY_VARIABLES } from '../config/appConfig';

/**
 * Обрабатывает condition блок - определяет следующий блок на основе значения переменной
 * @param {Object} block - Блок с типом "condition"
 * @param {Object} variables - Объект с переменными состояния
 * @returns {string|null} - ID следующего блока или null, если не найден
 */
export const handleCondition = (block, variables = {}) => {
  if (!block || block.type !== 'condition') {
    return null;
  }

  const variableName = block.variable;
  if (!variableName) {
    console.warn('Condition block missing variable name');
    return null;
  }

  let variableValue = variables[variableName];
  
  // Если переменная - массив, извлекаем значение для текущей фразы
  if (Array.isArray(variableValue) && !NON_ARRAY_VARIABLES.includes(variableName)) {
    const currentPhraseIndex = variables.currentPhraseIndex || 0;
    variableValue = variableValue[currentPhraseIndex];
  }
  
  // Если переменная не определена, возвращаем null
  if (variableValue === undefined || variableValue === null) {
    console.warn(`Variable ${variableName} is not defined`);
    return null;
  }

  // Преобразуем значение в строку для поиска в mapping
  // Обрабатываем boolean, number, string
  let valueKey;
  if (typeof variableValue === 'boolean') {
    valueKey = variableValue ? 'true' : 'false';
  } else {
    valueKey = String(variableValue);
  }
  
  // Ищем соответствующий nextId в mapping
  const mapping = block.mapping || {};
  let nextId = mapping[valueKey];

  // Если не найдено точное совпадение и переменная - число, проверяем специальные ключи
  if (!nextId && typeof variableValue === 'number') {
    // Проверяем ключ "default" для всех остальных значений
    if (mapping['default']) {
      nextId = mapping['default'];
    }
    // Проверяем ключи вида ">0" для значений больше 0
    if (!nextId && variableValue > 0 && mapping['>0']) {
      nextId = mapping['>0'];
    }
    // Проверяем ключи вида ">=1" для значений >= 1
    if (!nextId && variableValue >= 1 && mapping['>=1']) {
      nextId = mapping['>=1'];
    }
  }

  if (!nextId) {
    console.warn(`No mapping found for variable ${variableName} with value ${valueKey}`);
    return null;
  }

  return nextId;
};

